import type { AppStrings } from 'owa-acui';
import { computed } from 'mobx';
import loc from 'owa-localize';
import {
    bottomBarOverflowMenuLabel as CommandRibbonStrings_bottomBarOverflowMenuLabel,
    calloutCloseLabel as CommandRibbonStrings_calloutCloseLabel,
    clearSearch as CommandRibbonStrings_clearSearch,
    commandRibbonLabel as CommandRibbonStrings_commandRibbonLabel,
    leftRibbonPaddleLabel as CommandRibbonStrings_leftRibbonPaddleLabel,
    overflowWellKeytip as CommandRibbonStrings_overflowWellKeytip,
    peripheralControlsGroupLabel as CommandRibbonStrings_peripheralControlsGroupLabel,
    ribbonModeChevronKeytip as CommandRibbonStrings_ribbonModeChevronKeytip,
    ribbonModeChevronLabel as CommandRibbonStrings_ribbonModeChevronLabel,
    ribbonSearchLabel as CommandRibbonStrings_ribbonSearchLabel,
    rightRibbonPaddleLabel as CommandRibbonStrings_rightRibbonPaddleLabel,
    search as CommandRibbonStrings_search,
    searchableMenuRegionLabel as CommandRibbonStrings_searchableMenuRegionLabel,
    tabsContainerLabel as CommandRibbonStrings_tabsContainerLabel,
    tabsContainerOverflowLabel as CommandRibbonStrings_tabsContainerOverflowLabel,
    taskPaneOpeningString as CommandRibbonStrings_taskPaneOpeningString,
    taskPaneOverflowMenuLabel as CommandRibbonStrings_taskPaneOverflowMenuLabel,
    taskPaneRoleDescription as CommandRibbonStrings_taskPaneRoleDescription,
    taskPaneTabsContainerLabel as CommandRibbonStrings_taskPaneTabsContainerLabel,
} from 'owa-locstrings/lib/strings/commandRibbon.locstring.json';

const computeAppStrings = computed((): AppStrings => {
    return {
        overflowWellKeytip: loc(CommandRibbonStrings_overflowWellKeytip),
        bottomBarOverflowMenuLabel: loc(CommandRibbonStrings_bottomBarOverflowMenuLabel),
        ribbonLabel: loc(CommandRibbonStrings_commandRibbonLabel),
        tabsContainerLabel: loc(CommandRibbonStrings_tabsContainerLabel),
        tabsContainerOverflowLabel: loc(CommandRibbonStrings_tabsContainerOverflowLabel),
        peripheralControlsGroupLabel: loc(CommandRibbonStrings_peripheralControlsGroupLabel),
        closeLabel: loc(CommandRibbonStrings_calloutCloseLabel),
        taskPaneOverflowMenuLabel: loc(CommandRibbonStrings_taskPaneOverflowMenuLabel),
        ribbonModeChevronLabel: loc(CommandRibbonStrings_ribbonModeChevronLabel),
        ribbonModeChevronKeytip: loc(CommandRibbonStrings_ribbonModeChevronKeytip),
        taskPaneTabsContainerLabel: loc(CommandRibbonStrings_taskPaneTabsContainerLabel),
        taskPaneRoleDescription: loc(CommandRibbonStrings_taskPaneRoleDescription),
        taskPaneOpeningString: loc(CommandRibbonStrings_taskPaneOpeningString),
        rightRibbonPaddleLabel: loc(CommandRibbonStrings_rightRibbonPaddleLabel),
        leftRibbonPaddleLabel: loc(CommandRibbonStrings_leftRibbonPaddleLabel),
        search: loc(CommandRibbonStrings_search),
        searchLabel: loc(CommandRibbonStrings_ribbonSearchLabel),
        searchableMenuRegionLabel: loc(CommandRibbonStrings_searchableMenuRegionLabel),
        clearSearch: loc(CommandRibbonStrings_clearSearch),
    };
});

export const getAppStrings = (): AppStrings => computeAppStrings.get();
